import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useSeo } from "@/lib/useSeo";
import { Reveal, SectionHead } from "@/components/site/Reveal";
import Icon from "@/components/site/Icon";
import { Badge } from "@/components/ui/badge";

export default function Services() {
  useSeo({ title: "Services", description: "Explore Buddy Solution's full range of digital services: development, design, AI, marketing, SEO and more." });
  const { data: services = [] } = useQuery({ queryKey: ["services"], queryFn: async () => (await api.get("/services")).data });

  const cats = [...new Set(services.map((s) => s.category))];

  return (
    <div className="bs-container py-16 lg:py-20">
      <Reveal><SectionHead center eyebrow="Services" title="Everything you need to grow digitally"
        subtitle="A complete digital-solutions suite, delivered with premium craft. Every service is configurable and priced transparently." /></Reveal>

      {cats.map((cat) => (
        <div key={cat} className="mt-14">
          <div className="mb-6 flex items-center gap-3">
            <h2 className="font-display text-xl font-bold">{cat}</h2>
            <div className="h-px flex-1 bg-border" />
          </div>
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {services.filter((s) => s.category === cat).map((s, i) => (
              <Reveal key={s.slug} delay={i * 0.04}>
                <Link to={`/services/${s.slug}`} data-testid={`service-card-${s.slug}`}
                  className="group flex h-full flex-col bs-card p-6 hover:-translate-y-1 hover:border-primary/50 hover:shadow-glow">
                  <div className="mb-4 inline-flex w-fit rounded-xl bg-primary/12 p-3 text-primary transition-transform group-hover:scale-110"><Icon name={s.icon} /></div>
                  <h3 className="font-display text-lg font-bold">{s.title}</h3>
                  <p className="mt-2 flex-1 text-sm text-muted-foreground">{s.short_desc}</p>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="text-sm font-semibold">{s.starting_price ? `From $${s.starting_price.toLocaleString()}` : "Custom"}</span>
                    <ArrowRight className="h-4 w-4 text-primary opacity-0 transition-opacity group-hover:opacity-100" />
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
